



















  import { computed, defineComponent, ref } from 'vue'
  import useCurrentInstance from '~/utils/useCurrentInstance'

  export default defineComponent({
    name: 'OneBrandsDropdownComponent',
    components: {
      OneCmsBrandsList: () => import('~/components/organisms/list/OneCmsBrandsList.vue'),
    },
    setup() {
      const vm = useCurrentInstance()
      const togglingBrandsMenuHandler = ref<any>(null)

      const backdrop = computed(() => vm.$store.state.layout.backdrop)
      const menuBrandsShow = computed(() => vm.$store.state.layout.menuBrandsShow)
      const shouldShowComponent = computed(
        () => !vm.$tenantConfig.isPlatformClosed || vm.$auth.isAuthenticated,
      )
      const shouldShowDropdown = computed(() => !backdrop.value)

      const mouseOver = () => {
        if (shouldShowDropdown.value) {
          if (togglingBrandsMenuHandler.value) {
            clearTimeout(togglingBrandsMenuHandler.value)
          }
          togglingBrandsMenuHandler.value = setTimeout(() => {
            vm.$store.commit('layout/TOGGLE_BACKDROP', true)
            vm.$store.commit('layout/TOGGLE_BRANDS_MENU', true)
          }, 150)
        }
      }

      const mouseLeave = () => {
        if (togglingBrandsMenuHandler.value) {
          clearTimeout(togglingBrandsMenuHandler.value)
        }
        vm.$store.commit('layout/TOGGLE_BRANDS_MENU', false)
        vm.$store.commit('layout/TOGGLE_BACKDROP', false)
      }

      const onItemClick = (item: any) => {
        const manufacturerName = item?.brand?.name
        if (!manufacturerName) {
          return
        }
        vm.$store.commit('layout/TOGGLE_BRANDS_MENU', false)
        vm.$store.commit('layout/TOGGLE_BACKDROP', false)
      }

      return {
        menuBrandsShow,
        shouldShowComponent,
        mouseOver,
        mouseLeave,
        onItemClick,
      }
    },
  })
